/**
 * App Error Messages
 *
 */

const ERRORS = {
  // Defaults
  default: 'Hmm, an unknown error occurred',
  apiError: 'Missing params (AppAPI.fetcher).',
  notfound: 'The link your are trying to access is not valid.',
  timeout: 'Request timed out, it took way to long to receive response from server.'
};

export default ERRORS;